import { API_VERSION } from "@shared/constants";

const AUTH_BASE_URL = `${API_VERSION}/auth`;
const DASHBOARD_BASE_URL = `${API_VERSION}/dashboard`;
export const ALERTS_BASE_URL = `${API_VERSION}/alerts`;
export const COUNTRIES_BASE_URL = `${API_VERSION}/countries`;

// Auth
export const LOGOUT_URL = `${AUTH_BASE_URL}/logout`;

// Tickets
export const TICKETS_URL = `${API_VERSION}/tickets`;
export const TICKETS_EXPORT_URL = `${API_VERSION}/tickets/export`;

// Dashboard
export const LEADERBOARD_URL = `${DASHBOARD_BASE_URL}/leaderboard`;
export const TRENDS_URL = `${DASHBOARD_BASE_URL}/trends`;
export const DOMAINS_URL = `${DASHBOARD_BASE_URL}/domains`;
export const MISSING_BY_COUNTRY_URL = `${DASHBOARD_BASE_URL}/missing-by-country`;
export const VALIDATION_SUMMARY_URL = `${DASHBOARD_BASE_URL}/validation-summary`;
export const COUNTRIES_URL = `${COUNTRIES_BASE_URL}`;
export const COUNTRIES_EXPORT_URL = `${COUNTRIES_BASE_URL}/export`;
export const ALERTS_SUMMARY_URL = `${ALERTS_BASE_URL}/summary`;
export const ALERTS_URL = `${ALERTS_BASE_URL}`;
export const COMPANIES_URL = `${API_VERSION}/companies`;
/** Dashboard overview summary (KPIs, DQ score, etc.) - same base as KPI */
export const DASHBOARD_SUMMARY_URL = `${DASHBOARD_BASE_URL}/summary`;
export const KPI_URL = `${API_VERSION}/tickets/kpi`;
